import { JSX } from 'solid-js';
import {
  FileFolderItem,
  MissionDetailsSelection,
  RunDetailsSelection,
} from '@mobile-mapping/providers';
import { SharedProjectDataPanel } from '../selections/tree/shared-panel/SharedProjectDataPanel';

export const ProjectDataTab = (props: {
  onModelDetailsSelect?(model: FileFolderItem): void;
  onRunDetailsSelect?(run: RunDetailsSelection): void;
  onMissionDetailsSelect?(mission: MissionDetailsSelection): void;
}): JSX.Element => {
  return (
    <SharedProjectDataPanel
      onModelDetailsSelect={props.onModelDetailsSelect}
      onRunDetailsSelect={props.onRunDetailsSelect}
      onMissionDetailsSelect={props.onMissionDetailsSelect}
    />
  );
};
